
import TableList from "@components/templates/tablelist";
import { HttpGetBillNameList, HttpDeleteBillNameOne } from "@/service/newbigaccount";
import { mapState, mapGetters } from "vuex";
// import compIndex from './update'
export default {
    mixins: [TableList],
    // components:{
    //     compIndex
    // },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    EQ_expenseCategoryType:null
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },
    methods: {
        ajaxRequest: HttpGetBillNameList,
        
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{id:params},
                        title: "添加",
                        showDesc:false,
                        width:450,
                        formdata:[
                            {
                                label: "组织",
                                tag: 'vSelect',
                                key: 'organizationId',
                                show:true,
                                options:this.getBillcusorgList,
                                span:24,
                                props:{
                                    filterable:true,
                                }
                            },
                            {
                                label: '费用类型',
                                tag: 'vSelect',
                                key: 'expenseCategoryType',
                                options: this.getCusBillTypeList,
                                span:24,
                                props:{
                                    filterable:true,
                                },
                                show: true,
                            },
                        ],
                        ajaxRequest:HttpDeleteBillNameOne
                    }
                    break;
                case "delete":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{id:params},
                        title: "删除操作",
                        ajaxRequest:HttpDeleteBillNameOne
                    }
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'删除',
                show: true,
                params:id,
                operate:'delete'
            }, ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusBillTypeList']),
        ToolsData(){
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [
                {
                    label: "客户组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show:true,
                    options:this.getBillcusorgList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: '费用类型',
                    tag: 'vSelect',
                    key: 'EQ_expenseCategoryType',
                    options: this.getCusBillTypeList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '创建时间',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                }
            ]
        },
        columns() {
            return  [
                // {
                //     show:false,
                //     type: 'selection',
                //     width: 60,
                //     align: 'center',
                //     formName: 'id'
                // },
                {
                    title: '操作',
                    width: 90,
                    render:this.getOperateNodes,
                },
                {
                    title: '客户组织',
                    render: (h, { row }) => this.findRenderLabel(this.getBillcusorgList, row.organizationId),
                },
                {
                    title: '费用类型',
                    key: 'expenseCategoryType',
                    render: (h, { row }) => this.findRenderLabel(this.getCusBillTypeList, row.expenseCategoryType),
                },
                {
                    title: '创建人',
                    render: (h, { row }) => {
                        return <div>
                        <div>{row.createdName || '--'}</div>
                        </div>

                    },
                },
                {
                    title: '创建时间',
                    key:'createdAt'
                },
            ];
        },

    },

};
